import React, { useMemo } from 'react';
import FilterSelect from './FilterSelect';

export type SourceOption = { code: string; title: string; color?: string | null };

type Props = {
  sources: SourceOption[];
  value: string;
  onChange: (sourceCode: string) => void;
  placeholder?: string;
};

const SourceFilterSelect: React.FC<Props> = ({
  sources,
  value,
  onChange,
  placeholder = 'Все источники',
}) => {
  const options = useMemo(
    () => sources.map((s) => ({ value: s.code, label: s.title || s.code })),
    [sources]
  );

  return (
    <FilterSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default SourceFilterSelect;
